import { makeAutoObservable, runInAction } from 'mobx';
import { CheckboxFiltersStore } from '../model';
import __ from '../../../../../utils/translation';

const storeProductGroupFilters = makeAutoObservable<CheckboxFiltersStore>({
  list: [],
  label: __('Product group'),
  alias: 'product_group',
  setList(list) {
    runInAction(() => {
      storeProductGroupFilters.list = Object.entries(list)
        .map(([key, value]) => ({ id: parseInt(key), label: value }));
    });
  },
});

export default storeProductGroupFilters;
